export default {
  a6529: { name: { value: 'Apogee', disabled: true } },
  ab6Jk: { name: { value: 'Freedom Chiropractic', disabled: true } },
  af70x: { name: { value: 'The Glass Guru', disabled: true } },
  aF9C1: { name: { value: 'Eden Oaks', disabled: true } },
  aL6ee: { name: { value: 'BamPaws', disabled: true } },
  aQ4U6: { name: { value: 'GLOBE Charter School', disabled: true } },
  b74UQ: { name: { value: 'Harvey Investment Management', disabled: true } },
  bd4q0: { name: { value: 'Fillmore Veterinary Hospital', disabled: true } },
  bfwDl: { name: { value: 'Vanguard Skin Specialists', disabled: true } },
  bM1G1: { name: { value: 'Colorado Springs School District 11', disabled: true } },
  bpILQ: { name: { value: 'Unlimited Bodywork', disabled: true } },
  br7S2: { name: { value: 'Outreach Inc', disabled: true } },
  bX26m: { name: { value: 'PlayTime Pet Sitters and Dog Walkers', disabled: true } },
  bxugU: { name: { value: 'Colorado Hi-Tech Solutions', disabled: true } },
  c015e: { name: { value: 'REMAX Advantage', disabled: true } },
  c3q9G: { name: { value: 'All Care at Home Inc', disabled: true } },
  c707s: { name: { value: 'Pima Medical Institute', disabled: true } },
  cK0r7: { name: { value: 'The Platinum Group Realtors', disabled: true } },
  cl0n9: { name: { value: 'Pikes Peak National Bank', disabled: true } },
  clwDV: { name: { value: 'Bender Carey Group', disabled: true } },
  dA103: { name: { value: 'Century Communities', disabled: true } },
  deSSC: { name: { value: 'Heuser & Heuser LLP', disabled: true } },
  dGxG2: { name: { value: 'eviCore Healthcare', disabled: true } },
  dl41E: { name: { value: 'Life Well Lived Financial Group', disabled: true } },
  dtk7u: { name: { value: 'AMERGINT Technologies, Inc.', disabled: true } },
  due9s: { name: { value: 'Peak Vista Community Health Centers', disabled: true } },
  eA34q: { name: { value: 'TK Originals Custoim Embroidery', disabled: true } },
  eaje7: { name: { value: 'Navy Federal Credit Union', disabled: true } },
  ebIB9: { name: { value: 'House of Sk8', disabled: true } },
  eF4SN: { name: { value: 'Senior Resource Council', disabled: true } },
  ei8gE: { name: { value: 'Weidner Apartment Homes', disabled: true } },
  emiQ6: { name: { value: 'Oakwood Homes', disabled: true } },
  eOEkT: { name: { value: 'Griffith Centers for Children, Chin’s Up', disabled: true } },
  eoMa1: { name: { value: 'USA Triathlon', disabled: true } },
  eyGq2: { name: { value: 'StableStrides', disabled: true } },
  eYlKo: { name: { value: 'Davidson Technologies, Inc.', disabled: true } },
  f1I4f: { name: { value: 'The Summit', disabled: true } },
  f62Cy: { name: { value: 'Pikes Peak Workforce Center', disabled: true } },
  fQkb9: { name: { value: 'Bryan Construction Inc', disabled: true } },
  fr662: { name: { value: 'Handyman Connection', disabled: true } },
  fxI94: { name: { value: 'Nelson & Company, P.C.', disabled: true } },
  fzR31: { name: { value: 'Falcon High School', disabled: true } },
  g0bv5: { name: { value: 'Job Store Staffing', disabled: true } },
  g1qK9: { name: { value: 'Pikes Peak Library District', disabled: true } },
  g77Y7: { name: { value: 'Bank of the San Juans', disabled: true } },
  g7Byr: { name: { value: 'Thrivent Finanacial', disabled: true } },
  g9fD3: { name: { value: 'Peak Structural Inc', disabled: true } },
  gn484: { name: { value: 'RE/MAX Integrity', disabled: true } },
  goIM3: { name: { value: 'HomeAdvisor', disabled: true } },
  gr2lI: { name: { value: 'Better Business Bureau of Southern Colorado', disabled: true } },
  gRHds: { name: { value: 'Berwick Electric Co', disabled: true } },
  h4Pr9: { name: { value: 'Twelve Legs Marketing', disabled: true } },
  h5bpM: { name: { value: 'Elevated Insights', disabled: true } },
  hAbTU: { name: { value: 'Red Noland Auto Group', disabled: true } },
  hELnJ: { name: { value: 'NFP Corporate Services (CO), Inc.', disabled: true } },
  hGPfb: { name: { value: 'Builder Funnel', disabled: true } },
  hoeNQ: { name: { value: 'Cordera Family Dentistry', disabled: true } },
  hPfMh: { name: { value: 'Clover Network, Inc.', disabled: true } },
  hWjBi: { name: { value: 'Tailored Knowledge Resources', disabled: true } },
  hWtH9: { name: { value: 'Classic Homes', disabled: true } },
  i16y1: { name: { value: 'Bettner Vision', disabled: true } },
  i2xK7: { name: { value: 'FYZICAL Therapy and Balance Centers', disabled: true } },
  i3CFW: { name: { value: 'Diversified Association Management', disabled: true } },
  i52iC: { name: { value: 'SocialSEO', disabled: true } },
  i57yx: { name: { value: 'MGA Homecare', disabled: true } },
  i6xE4: { name: { value: 'Titan Robotics, Ltd.', disabled: true } },
  i8lxr: { name: { value: 'YMCA of the Pikes Peak Region', disabled: true } },
  ic89j: { name: { value: 'Griffis/Blessing, Inc', disabled: true } },
  icNny: { name: { value: 'ERA Shields Real Estate', disabled: true } },
  icS0F: { name: { value: 'Mollner Dentistry at the Citadel', disabled: true } },
  id259: { name: { value: 'The Shafer Group PC', disabled: true } },
  iD2m9: { name: { value: 'Widefield School District', disabled: true } },
  iF57D: { name: { value: 'Jason Daniels & Associates at RE/MAX Millennium', disabled: true } },
  iGf8Y: { name: { value: 'Hammers Construction', disabled: true } },
  iGgfz: { name: { value: 'RE/MAX Properties, Inc.', disabled: true } },
  isiuG: { name: { value: 'Edward Jones', disabled: true } },
  jG74p: { name: { value: 'Pikes Peak Dream Homes Realty', disabled: true } },
  jgNoX: { name: { value: 'Luisa Graff Jewelers', disabled: true } },
  jH8jo: { name: { value: 'Budget Blinds', disabled: true } },
  jk4l9: { name: { value: 'New Summit Charter Academy', disabled: true } },
  jV8UU: { name: { value: 'Broadmoor Dental', disabled: true } },
  k2hsF: { name: { value: 'Modern Technology Solutions, Inc. (MTSI)', disabled: true } },
  k5Tr8: { name: { value: 'Formstack', disabled: true } },
  k6wso: { name: { value: 'Frontier IT', disabled: true } },
  k96I0: { name: { value: 'Premier Roofing Company', disabled: true } },
  k9qUe: { name: { value: 'Good Company restaurant and Bar', disabled: true } },
  k9y7d: { name: { value: 'Revolution Jewelry Works', disabled: true } },
  kCuGq: { name: { value: 'The Cutting Edge, Realtors', disabled: true } },
  kk0s8: { name: { value: 'Strive Physical Therapy', disabled: true } },
  kquoe: { name: { value: 'The Wirenut', disabled: true } },
  ksr0g: { name: { value: 'T-Mobile', disabled: true } },
  ktE39: { name: { value: 'Core Chiropractic', disabled: true } },
  kTHQE: { name: { value: 'Century 21 Curbow Realty', disabled: true } },
  kU4v5: { name: { value: 'Terra Verde', disabled: true } },
  kz6DW: { name: { value: 'Cherwell Software', disabled: true } },
  l33Sp: { name: { value: 'Amada Senior Care', disabled: true } },
  l7I1U: { name: { value: 'Envision Radiology', disabled: true } },
  l7l0A: { name: { value: 'Blazer Electric Supply', disabled: true } },
  l8guH: { name: { value: 'Phil Long Dealerships', disabled: true } },
  lCibn: { name: { value: 'GH Phipps Construction Companies', disabled: true } },
  lfrqS: { name: { value: 'Roger Humphreys, DDS', disabled: true } },
  lhHQJ: { name: { value: 'The Family Care Center, LLC', disabled: true } },
  lMV4S: { name: { value: 'Torch Technologies, Inc.', disabled: true } },
  lUA8R: { name: { value: 'Dr Mark Mollner, DDS', disabled: true } },
  lv5S7: { name: { value: 'a360inc. Firm Solutions', disabled: true } },
  lZt7j: { name: { value: 'Wilson & Company', disabled: true } },
  m7G6X: { name: { value: 'Sonesta ES Suites', disabled: true } },
  mb2Z2: { name: { value: 'Icing on the Cake', disabled: true } },
  mEe5a: { name: { value: 'Cause and Solution, Inc.', disabled: true } },
  mfL50: { name: { value: 'Bible Electric', disabled: true } },
  mh5GW: { name: { value: 'Once Upon A Childcare', disabled: true } },
  mv4TT: { name: { value: 'Lees Janitorial ', disabled: true } },
  mV8aA: { name: { value: 'Wildcat Construction', disabled: true } },
  mVwvQ: { name: { value: 'McDivitt Law Firm', disabled: true } },
  mxr9S: { name: { value: 'Pikes Peak Association of REALTORS', disabled: true } },
  myOfi: { name: { value: 'Aspen Auto Clinic', disabled: true } },
  n7pxf: { name: { value: 'Altia Inc', disabled: true } },
  n9DLO: { name: { value: 'Community Banks of Colorado', disabled: true } },
  n9PX2: { name: { value: 'CPCD...giving children a head start', disabled: true } },
  nBRsl: { name: { value: 'Space Foundation', disabled: true } },
  ncKJA: { name: { value: 'Briargate Boulevard Animal Hospital', disabled: true } },
  nGoiZ: { name: { value: 'Memorial Gardens Funeral Home', disabled: true } },
  njs24: { name: { value: 'Mission Medical Center', disabled: true } },
  nX18Y: { name: { value: 'Secureset Colorado Springs', disabled: true } },
  o3J41: { name: { value: 'Mr. Sandless', disabled: true } },
  o84j2: { name: { value: 'Young Scholars Academy', disabled: true } },
  o8V1g: { name: { value: 'Infinity Systems Engineering', disabled: true } },
  oNmrU: { name: { value: 'Black Forest Brewing Company', disabled: true } },
  oOP61: { name: { value: 'Coldwell Banker Residential Brokerage', disabled: true } },
  oQpx4: { name: { value: 'Planet Granite', disabled: true } },
  oWy1W: { name: { value: 'Alpine Contracting', disabled: true } },
  oxe3M: { name: { value: 'Pink Realty', disabled: true } },
  oYX1B: { name: { value: 'University of Colorado Colorado Springs', disabled: true } },
  p18dA: { name: { value: 'Pikes Peak Community College', disabled: true } },
  p1Ge9: { name: { value: 'HB&A Architecture and Planning', disabled: true } },
  p65A6: { name: { value: 'Sellstate Alliance Realty', disabled: true } },
  pm262: { name: { value: 'The Warren Management Group, Inc. AAMC', disabled: true } },
  pmbEM: { name: { value: 'Team Select Home Care', disabled: true } },
  pW3cz: { name: { value: 'Comcast', disabled: true } },
  pxCHs: { name: { value: 'Sweet Celebrations', disabled: true } },
  q5cD1: { name: { value: 'Erickson, Brown & Kloster PC', disabled: true } },
  qOdFF: { name: { value: 'The Resource Exchange', disabled: true } },
  r0HyC: { name: { value: 'LVW Electronics', disabled: true } },
  rEA02: { name: { value: 'The Retreat at Sunny Vista, Sunny Vista Living Center', disabled: true } },
  rF95q: { name: { value: 'Blue Picket Realty', disabled: true } },
  rGl0z: { name: { value: 'Mercedes Benz of Colorado Springs', disabled: true } },
  rjItK: { name: { value: 'HDR', disabled: true } },
  rwp54: { name: { value: 'Care and Share', disabled: true } },
  s09F7: { name: { value: 'Atrevida Beer Company', disabled: true } },
  sDuRf: { name: { value: 'Axis Business Technologies', disabled: true } },
  sKI2I: { name: { value: 'Waypoint Bank', disabled: true } },
  smGC8: { name: { value: 'Access Products, Inc.', disabled: true } },
  t1i4B: { name: { value: 'Edward Jones', disabled: true } },
  t6B6B: { name: { value: 'Martin Marietta Materials', disabled: true } },
  t87ws: { name: { value: 'Rangewood Orthodontics', disabled: true } },
  tfG8L: { name: { value: 'Thrivent Finanacial', disabled: true } },
  thBp4: { name: { value: 'UCHealth', disabled: true } },
  tj0b0: { name: { value: 'Brickleys Property Solutions', disabled: true } },
  tJQ9t: { name: { value: 'Bullseye Plumbing And Heating', disabled: true } },
  tmi7X: { name: { value: 'Shandy Clinic', disabled: true } },
  tVuV9: { name: { value: 'Melody Living Colorado Springs', disabled: true } },
  txMVF: { name: { value: 'Mayfield Counseling Centers', disabled: true } },
  tYUYo: { name: { value: 'Flow Right Plumbing, Heating & Cooling', disabled: true } },
  u4h0r: { name: { value: 'SERVPRO', disabled: true } },
  uArw0: { name: { value: 'Homefix', disabled: true } },
  uIq2t: { name: { value: 'Local Motive Events', disabled: true } },
  uNpY5: { name: { value: 'Colorado Behavior and Learning Group', disabled: true } },
  v6suZ: { name: { value: 'Forbush Legal, PLLC', disabled: true } },
  viw02: { name: { value: 'Pikes Peak Habitat for Humanity', disabled: true } },
  vkMVp: { name: { value: 'Maid to Shine', disabled: true } },
  vNuXJ: { name: { value: 'Colorado Structures Inc., dba.CSI Construction Company', disabled: true } },
  vP3SG: { name: { value: 'Harrison School District Two', disabled: true } },
  vqMLa: { name: { value: 'Ent Credit Union', disabled: true } },
  vqRDR: { name: { value: 'Action Ready Mix, LLC', disabled: true } },
  vsMXA: { name: { value: 'Kissing Camels Family Dentistry', disabled: true } },
  w2PZ7: { name: { value: 'Rampart Plumbing Supply', disabled: true } },
  w5a5H: { name: { value: 'Colorado Health and Rehab (Strive Physical Therapy)', disabled: true } },
  w78T9: { name: { value: 'Diamond Express Transportation', disabled: true } },
  wda4t: { name: { value: 'Microchip Technology, Inc', disabled: true } },
  wG3K2: { name: { value: 'Synergy Realty Group', disabled: true } },
  wiqnJ: { name: { value: 'Ameriprise Financial', disabled: true } },
  wox68: { name: { value: 'Cosmic Advanced Engineered Solutions', disabled: true } },
  wSwo9: { name: { value: 'Centauri', disabled: true } },
  wTlgE: { name: { value: 'Elements Massage BRIARGATE', disabled: true } },
  x0pBp: { name: { value: 'Advantage Manufacturing', disabled: true } },
  x2Gxo: { name: { value: 'Xledger Inc', disabled: true } },
  x2X7D: { name: { value: 'Dynamic Physical Therapy', disabled: true } },
  x4KZ0: { name: { value: 'El Paso Electric LLC', disabled: true } },
  x96Kt: { name: { value: 'Mulliken Weiner Berg & Jolivet P.C.', disabled: true } },
  xewer: { name: { value: 'Spherion', disabled: true } },
  xf652: { name: { value: 'Treasure Davis Team Real Estate', disabled: true } },
  xGQ53: { name: { value: 'Inside Out Youth Services', disabled: true } },
  xqqoc: { name: { value: 'The Faricy Boys Chrysler jeep', disabled: true } },
  xrG2a: { name: { value: 'Security Service Federal Credit Union', disabled: true } },
  xVH9l: { name: { value: 'JE Dunn Construction', disabled: true } },
  xXkAS: { name: { value: 'Integrity Bank & Trust', disabled: true } },
  y33Qx: { name: { value: 'Around the Block Realty', disabled: true } },
  y8PeG: { name: { value: 'Blue Staq', disabled: true } },
  y91V1: { name: { value: 'Air Academy Federal Credit Union', disabled: true } },
  ybGio: { name: { value: 'Creative Chaos Salon', disabled: true } },
  ycbN6: { name: { value: 'Crossroads Family Dentistry', disabled: true } },
  yEXuf: { name: { value: 'Epicentral Coworking', disabled: true } },
  yFyeS: { name: { value: 'Oskar Blues Fooderies', disabled: true } },
  yXmlB: { name: { value: 'Exigo Corporation', disabled: true } },
  z559m: { name: { value: 'TCA', disabled: true } },
  zh2zJ: { name: { value: 'Sunny Vista Living Center', disabled: true } },
  zkY2b: { name: { value: 'The Shafer Group', disabled: true } },
  zm91Z: { name: { value: 'Skyline Vision Clinic & Laser Center', disabled: true } },
  q4Pdl: { name: { value: 'El Paso County Planning and Community Development', disabled: true } },
  xPgi9: { name: { value: 'ERC', disabled: true } },
  s9LET: { name: { value: 'Frankie\'s Too', disabled: true } },
  jKimI: { name: { value: 'Lexisnexis', disabled: true } },
  k51b3: { name: { value: 'The Broadmoor', disabled: true } },
  fz82f: { name: { value: 'Vectrus', disabled: true } },
  f5y2f: { name: { value: 'Altitude Hospitality Group', disabled: true } },
  l4Jp9: { name: { value: 'Brookdale Senior Living', disabled: true } },
  mK3n2: { name: { value: 'Example Company' } },


  defaultError: 'We\'re sorry, the survey link is either broken or expired.<br>Please reach out to your HR department to get a corrected link.',
  enableRoot: false,
};
